import { unitFormat } from '../../../helpers/money'
import { Button, Icon } from 'semantic-ui-react'
import { CSVLink } from 'react-csv'
import { useTranslation } from 'react-i18next'
import useUser from '../../Shared/UserProvider/useUser'
import { getSymbolFromCode } from "currency-code-symbol-map"

const ExportButton = ({ unavailableItems }) => {
    const [t] = useTranslation()
    const { user } = useUser()

    function getData() {
        if (!unavailableItems || unavailableItems?.length === 0) {
            return []
        }

        return [
            [
                t('unavailable_items.product.barcode'),
                t('unavailable_items.product.name'),
                t('unavailable_items.product.missed_quantity'),
                t('unavailable_items.product.missed_revenue'),
            ],
        ].concat(unavailableItems.map((unavailableItem) => ([
            unavailableItem.barcode.replace(/"/g, '""'),
            unavailableItem.name.replace(/"/g, '""'),
            `${unavailableItem.quantity} ${(unavailableItem?.sellableUnit?.type !== 'COUNT' && unavailableItem?.sellableUnit?.unit) ? t(`measurement_unit.symbols.${unavailableItem.sellableUnit.unit}`) : ''}`,
            unavailableItem.totalPrice ? `${unitFormat(unavailableItem.totalPrice, user.getCompanyCurrency())} ${getSymbolFromCode(user.getCompanyCurrency())}` : '-'
        ])))
    }

    return (
      <CSVLink
        className="csv-btn"
        separator=";"
        data={getData()}
        filename={t('unavailable_items.export_file_name')}
      >
          <Button icon disabled={!unavailableItems || unavailableItems.length === 0}>
              <Icon name="cloud download"/>
          </Button>
      </CSVLink>
    )
}

export { ExportButton }
